"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.format_offset = exports.parse_offset = exports.get_locale = exports.get_offset = exports.create = exports.parse = exports.relative_format = exports.format = exports.current_locale = exports.sort_locale_list = exports.locale_list = void 0;
var luxon_1 = require("luxon");
exports.locale_list = [
    ['Etc/UTC', 'UTC'],
    ['Europe/London', 'Dublin, Lisbon, London'],
    ['Europe/Paris', 'Berlin, Rome, Paris'],
    ['Africa/Ndjamena', 'West Central Africa'],
    ['Europe/Athens', 'Athens, Beirut, Bucharest, Istanbul'],
    ['Africa/Harare', 'Harare, Pretoria'],
    ['Europe/Moscow', 'Moscow, Riyadh, St. Petersburg'],
    ['Asia/Dubai', 'Dubai'],
    ['Asia/Kabul', 'Kabul'],
    ['Asia/Karachi', 'Islamabad, Karachi'],
    ['Asia/Kolkata', 'Kolkata, Mumbai, New Delhi'],
    ['Asia/Dhaka', 'Dhaka'],
    ['Asia/Bangkok', 'Bangkok, Hanoi, Jakarta'],
    ['Asia/Hong_Kong', 'Beijing, Chongqing, Hong Kong, Singapore'],
    ['Australia/Perth', 'Perth'],
    ['Asia/Tokyo', 'Osaka, Sapporo, Seoul, Tokyo'],
    ['Australia/Adelaide', 'Adelaide, Darwin'],
    ['Australia/Sydney', 'Canberra, Melbourne, Sydney'],
    ['Pacific/Auckland', 'Auckland, Wellington'],
    ['Pacific/Tongatapu', 'Tonga'],
    ['Atlantic/Azores', 'Azores'],
    ['America/Sao_Paulo', 'Brasilia'],
    ['America/Buenos_Aires', 'Buenos Aires'],
    ['America/Barbados', 'Barbados, Roraima'],
    ['America/Santiago', 'Labrador, Santiago'],
    ['America/Caracas', 'Caracas'],
    ['America/New_York', 'Eastern Time'],
    ['America/Bogota', 'Bogota, Lima, Quito'],
    ['America/Chicago', 'Central Time (US & Canada)'],
    ['America/Costa_Rica', 'Central Time (Costa Rica)'],
    ['America/Mexico_City', 'Central America'],
    ['America/Phoenix', 'Arizona'],
    ['America/Denver', 'Mountain Time'],
    ['America/Mazatlan', 'Chihuahua, La Paz, Mazatlan'],
    ['America/Los_Angeles', 'Pacific Time'],
    ['US/Alaska', 'Alaska'],
    ['US/Hawaii', 'Hawaii'],
    ['Pacific/Samoa', 'Samoa'],
];
var ts_pattern = /((\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}(?::\d{2}))) (\w+\/\w+)/;
function sort_locale_list(_now, _list) {
    var list = _list || exports.locale_list;
    var now = _now || Date.now();
    var result = list.slice().sort(function (a, b) {
        var aOffset = get_offset(a[0], now);
        var bOffset = get_offset(b[0], now);
        // Order offsets from large to small (west to east)
        return -(aOffset - bOffset);
    });
    return result;
}
exports.sort_locale_list = sort_locale_list;
/**
 * Returns the timezone that best matches the browser timezone.
 *
 * @param original_tz: if provided, use this timezone instead of the browser
 *  timezone. Primarily used for unit testing purposes.
 */
function current_locale(original_tz) {
    var tz = original_tz !== null && original_tz !== void 0 ? original_tz : Intl.DateTimeFormat().resolvedOptions().timeZone;
    // If timezone is in locale_list, return it
    if (exports.locale_list.find(function (loc) { return loc[0] === tz; })) {
        return tz;
    }
    // Next, try to find a fuzzy match
    var fuzzyMatch = exports.locale_list.find(function (loc) { return isFuzzyMatch(loc[0], tz); });
    if (fuzzyMatch) {
        return fuzzyMatch[0];
    }
    // Fall back to UTC
    return 'Etc/UTC';
    /**
     * Check if two timezones have the same offset on two dates:
     * January 1 and July 1 of the current year.
     * @param tz1 - first IANA timezone
     * @param tz2 - second IANA timezone
     */
    function isFuzzyMatch(tz1, tz2) {
        var zone1 = luxon_1.IANAZone.create(tz1);
        var zone2 = luxon_1.IANAZone.create(tz2);
        if (!zone1.isValid || !zone2.isValid) {
            return false;
        }
        var now = new Date();
        var jan = new Date(now.getFullYear(), 0, 1);
        var jul = new Date(now.getFullYear(), 6, 1);
        return (zone1.offset(jan.valueOf()) === zone2.offset(jan.valueOf()) &&
            zone1.offset(jul.valueOf()) === zone2.offset(jul.valueOf()));
    }
}
exports.current_locale = current_locale;
function format(time, locale, pattern) {
    var dt = toDateTime(time);
    locale = locale || 'Etc/UTC';
    var local_dt = dt.setZone(locale);
    if (pattern) {
        return toStrftimeFormat(local_dt, pattern);
    }
    else {
        return toStrftimeFormat(local_dt, '%FT%T ' + locale);
    }
}
exports.format = format;
function format_date(time, locale) {
    return format(time, locale || null, '%Y-%m-%d');
}
format.date = format_date;
function format_time(time, locale) {
    return format(time, locale || null, '%H:%M:%S');
}
format.time = format_time;
function format_date_offset(time, locale) {
    return format(time, locale || null, '%z');
}
format.offset = format_date_offset;
function relative_format(ts, pattern) {
    return format(ts, get_locale(ts), pattern);
}
exports.relative_format = relative_format;
function parse(time) {
    return toDateTime(time).toJSDate();
}
exports.parse = parse;
function create(date, time, locale) {
    return (date + 'T' + time + ' ' + locale);
}
exports.create = create;
function get_offset(locale, date) {
    return parse_offset(format.offset(date, locale));
}
exports.get_offset = get_offset;
function get_locale(ts) {
    var match = ts.match(ts_pattern);
    return match ? match[4] : null;
}
exports.get_locale = get_locale;
function parse_offset(offset) {
    offset = offset.slice(-5);
    var hours = parseInt(offset.slice(1, 3)) * 60 * 60 * 1000;
    var minutes = parseInt(offset.slice(3, 5)) * 60 * 1000;
    return (hours + minutes) * (offset.charAt(0) === '-' ? 1 : -1);
}
exports.parse_offset = parse_offset;
function format_offset(delta) {
    var sign = delta > 0 ? '-' : '+';
    var hours = (Math.abs(delta) / 60) | 0;
    var minutes = Math.abs(delta) - hours * 60;
    return sign + pad(hours) + pad(minutes);
}
exports.format_offset = format_offset;
function pad(n) {
    var result = n + '';
    while (result.length < 2) {
        result = '0' + result;
    }
    return result;
}
/**
 * Private function for converting all supported types (timestamps, Date
 * objects, ISO datetimes, and Posix times) to a luxon DateTime object.
 *
 * If the provided date is a timestamp, the returned DateTime will be in the
 * timestamp's timezone. Otherwise, the DateTime will be in UTC.
 */
function toDateTime(date) {
    if (date instanceof Date) {
        return luxon_1.DateTime.fromJSDate(date, { zone: 'Etc/UTC' });
    }
    else if (typeof date === 'number') {
        return luxon_1.DateTime.fromMillis(date, { zone: 'Etc/UTC' });
    }
    else {
        // first, try to parse as timestamp
        var tsLuxonFormat = "yyyy-MM-dd'T'HH:mm:ss z";
        var dt = luxon_1.DateTime.fromFormat(date, tsLuxonFormat);
        if (!dt.invalidReason) {
            return dt;
        }
        // next, try to parse as ISO string
        dt = luxon_1.DateTime.fromISO(date, { zone: 'Etc/UTC' });
        if (!dt.invalidReason) {
            return dt;
        }
        // for backwards compatibility, try to parse a few alternate formats
        // 2020-10-10 05:06:07 America/Los_Angeles
        var alternameFormatWithTimezone = 'yyyy-MM-dd HH:mm:ss z';
        dt = luxon_1.DateTime.fromFormat(date, alternameFormatWithTimezone);
        if (!dt.invalidReason) {
            return dt;
        }
        // 2020-10-10 05:06:07
        var alternateFormatWithoutTimezone = 'yyyy-MM-dd HH:mm:ss';
        dt = luxon_1.DateTime.fromFormat(date, alternateFormatWithoutTimezone, {
            zone: 'Etc/UTC',
        });
        if (!dt.invalidReason) {
            return dt;
        }
        throw new Error('could not parse ' + date);
    }
}
function toStrftimeFormat(datetime, strftimeFormat) {
    var luxonFormat = strftimeFormatToLuxon(strftimeFormat);
    return datetime.toFormat(luxonFormat);
    function strftimeFormatToLuxon(pattern) {
        var tokenMap = new Map([
            ['%Y', 'yyyy'],
            ['%y', 'yy'],
            ['%m', 'MM'],
            ['%b', 'MMM'],
            ['%B', 'MMMM'],
            ['%a', 'ccc'],
            ['%A', 'cccc'],
            ['%e', 'd'],
            ['%d', 'dd'],
            ['%H', 'HH'],
            ['%l', 'h'],
            ['%M', 'mm'],
            ['%S', 'ss'],
            ['%p', 'a'],
            ['%z', 'ZZZ'],
            ['%Z', 'ZZZZ'],
            ['%F', 'yyyy-MM-dd'],
            ['%T', 'HH:mm:ss'],
        ]);
        // the strftime characters not yet converted- we'll gradually remove these
        var remainder = pattern;
        // the luxon pattern in progress- we'll gradually append to this
        var newFormat = '';
        // break once all characters are converted
        while (remainder) {
            var alphanumericMatch = remainder.match(/^\w+/);
            if (remainder[0] === '%') {
                // This is a strftime token; replace with its luxon equivalent
                var strftimeToken = remainder.slice(0, 2);
                var luxonToken = tokenMap.get(strftimeToken);
                if (!luxonToken) {
                    throw new Error(strftimeToken + " is not a supported strftime token");
                }
                newFormat += luxonToken;
                remainder = remainder.slice(2);
            }
            else if (alphanumericMatch) {
                // This is a group of letters/numbers, which is interpreted literally
                // in strftime. In luxon, we need to surround the word with single quotes
                // so it isn't interpreted as formatting tokens.
                var wordLength = alphanumericMatch[0].length;
                newFormat += "'" + remainder.slice(0, wordLength) + "'";
                remainder = remainder.slice(wordLength);
            }
            else {
                // This is something else, like a dash or colon; copy it to luxon as-is
                newFormat += remainder.slice(0, 1);
                remainder = remainder.slice(1);
            }
        }
        return newFormat;
    }
}
